export default {
  "ThirdPartyModal.Title1": "基本情報",
  "ThirdPartyModal.Title2": "法人ユーザー情報",
  "ThirdPartyModal.Title3": "利用情報",
  "ThirdPartyModal.Title4": "位置情報",
  "ThirdPartyModal.Title5": "医療健康情報",
  "ThirdPartyModal.Value1":
    "お客さまの識別子、属性、連絡先、ドコモビジネスポイントサービスのご利用に関する情報です。例として、性別、住所、ドコモビジネスポイント残高、ドコモビジネスポイント利用履歴などが含まれます",
  "ThirdPartyModal.Value2":
    "お客さまの勤務先、従業員属性に関する情報です。例として、会社名、会社所在地、業種、部署名、職種、役職、メールアドレスなどが含まれます",
  "ThirdPartyModal.Value3":
    "各種サービスなどのご契約・ご利用などに関する情報です。例として、ドコモおよびNTTドコモビジネス株式会社の各種サービスのご契約状態・ご利用履歴・投稿された記事や画像・動画に関する情報、インターネット利用時の行動に関する情報、アプリケーション利用時の行動に関する情報、購入されたサービスや商品の名称・購入場所・決済に関する情報、アンケートの回答に関する情報などが含まれます。ただし、基本情報、法人ユーザー情報、位置情報、医療健康情報に該当する情報は除きます",
  "ThirdPartyModal.Value4":
    "移動体端末の所持者の所在を表す場所を示す情報です。例として、端末のGPS機能のほか、Wi-Fiまたはそのほかの近距離無線通信技術、携帯電話基地局により測位される位置情報（位置登録情報を含みますが、これに限りません）などが含まれます",
  "ThirdPartyModal.Value5":
    "ドコモおよびNTTドコモビジネス株式会社のサービスを利用した際に取得される、お客さまの医療や健康に関する情報です。例として、医師などによる健康診断そのほかの検査に関する情報、医師などによる保健指導・診療・調剤に関する情報、お客さまの身長・体重、活動量などが含まれます",
  "ThirdPartyModal.CloseButton": "閉じる",
}
